import config from '../../config';
import makeUrl from '../../lib/makeUrl';

export const featuredByList = [
  {
    href:
      'https://www.lonelyplanet.com/news/2016/06/29/nepal-goes-hi-tech-new-app-trekking/',
    imgSrc: 'https://s3.amazonaws.com/honeyguide/assets/lp-org.jpg',
  },
  {
    href: 'https://besthike.com/2018/09/07/new-app-trekking-in-nepal/',
    imgSrc: 'https://s3.amazonaws.com/honeyguide/assets/besthike.jpg',
  },
  {
    href: 'https://www.infodev.org/articles/transforming-tourism-nepal-one-trek-time',
    imgSrc: 'https://s3.amazonaws.com/honeyguide/assets/woldbank.jpg',
  },
  {
    href:
      'https://bwdisrupt.businessworld.in/article/7-Startups-in-Nepal-That-Caught-Our-Eye-/23-06-2016-99539/',
    imgSrc: 'https://s3.amazonaws.com/honeyguide/assets/businessworld.jpg',
  },
  {
    href: 'https://www.kimkim.com/c/best-apps-for-nepal',
    imgSrc: 'https://s3.amazonaws.com/honeyguide/assets/kimkim.jpg',
  },
  {
    href: 'https://www.slush.org/company/honeyguide-apps/',
    imgSrc: 'https://s3.amazonaws.com/honeyguide/assets/slush.jpg',
  },
];

export const footerQuotes = [
  {
    quote_1: 'Going to the mountains',
    quote_2: 'is going home',
    author: 'John Muir',
  },
  {
    quote_1: 'Great things are done when',
    quote_2: 'men and mountains meet',
    author: 'William Blake',
  },
  {
    quote_1: 'There is no such thing as bad weather,',
    quote_2: 'only inappropriate clothing',
    author: 'Sir Ranulph Fiennes',
  },
];

export const otherLinks = {
  // youtubeUrl: 'https://www.youtube.com/embed/huei98Y6Cq0',
  youtubeUrl: 'https://www.youtube.com/embed/QDg23cCuc5E',
  playStoreUrl:
    'https://play.google.com/store/apps/details?id=com.trekkinginnepal.app&hl=en',
  appStoreUrl: 'https://itunes.apple.com/np/app/trekking-in-nepal/id1112263577?mt=8',
};

export const socialMediaLinks = [
  { text: 'facebook', link: 'https://www.facebook.com/honeyguideapp/' },
  { text: 'twitter', link: 'https://twitter.com/honeyguideapps' },
  { text: 'instagram', link: 'https://www.instagram.com/honeyguideapps/' },
  { text: 'pinterest', link: 'https://www.pinterest.com/honeyguideapps/' },
  { text: 'google-plus', link: 'https://plus.google.com/+Honeyguideapps' },
];

export const emails = [
  {
    text: 'Ashish Shrestha',
    email: 'honeyhunter@honeyguideapps.com',
    number: '+977-9841370673',
  },
  // { text: 'Business/Marketing', email: 'thebeekeeper@honeyguideapps.com', },
  // { text: 'Technical', email: 'idwaker@gmail.com', },
];
export const address = [
  {
    country: 'United States Office',
    address1: '2035 Sunset Lake Rd Suite B-2,',
    address2: 'Newark, New Castle, DE-19702.',
  },
  {
    country: 'India Office',
    address1: 'Flat No 1-D, Top Floor, DDA Flats Pocket-1, Sector-7,',
    address2: 'Dwarka, New Delhi-110075, Delhi.',
  },
  {
    country: 'Nepal Office',
    address1: 'Nuwakott Ghar, Sanepa Chowk,',
    address2: 'Lalitpur-44700, Province Number-3.',
  },
];

export const companyLinks = [
  { text: 'About Us', link: '/about-us' },
  { text: 'Places', link: '/places' },
  { text: 'Explore', link: '/explore' },
  { text: 'Blog', link: '/blog/' },
  { text: 'Careers', link: '/careers' },
  { text: 'Privacy Policy', link: '/policies/privacy' },
  { text: 'Terms of Services', link: '/policies/terms-services' },
  { text: 'Press Center', link: '/partners/press-center' },
];

export const NavLinks = [
  { name: 'Explore', url: makeUrl.goToExplore },
  { name: 'Treks', url: makeUrl.goToTreks },
  { name: 'Place', url: makeUrl.goToPlaces },
];

export const TrekLists = [
  {
    name: 'Everest Base Camp Trek',
    day: 12,
    url: 'https://honeyguideapps.com/treks/everest-base-camp-trek.e72a26f22199.everest-region',
    price: '',
    img: 'everest-three-passes-trek.jpg',
  },
  {
    name: 'Namche Trek',
    day: 5,
    url: 'https://honeyguideapps.com/treks/namche-trek.e781a1c9df18.everest-region',
    price: '',
    img: 'everest-base-camp-trek-gokyo.jpg',
  },
  {
    name: 'Helicopter Tour to EBC and Gokyo',
    day: 2,
    url: 'https://honeyguideapps.com/treks/helicopter-tour-to-everest-base-camp-and-gokyo-lakes.e716f033df6b.everest-region',
    price: '',
    img: 'everest-panorama-trek.jpg',
  },
  {
    name: 'Book Flight to Lukla',
    day: null,
    url: 'https://honeyguideapps.com/flights',
    price: '',
    img: 'salleri-to-everest-base-camp-trek.jpg',
  },
  {
    name: 'Book Hotels in Everest Region',
    day: null,
    url: 'https://honeyguideapps.com/lodges',
    price: '',
    img: 'everest-base-camp-trek-gokyo-chola.jpg',
  },
  {
    name: 'Book the best Guides at Lukla',
    day: null,
    url: 'https://honeyguideapps.com/guides/list/?baseCity=lukla',
    price: '',
    img: 'everest-base-camp-trek-pheriche.jpg',
    extraClassName: '',
  },
  {
    name: 'EBC with Gokyo Lakes Trek',
    day: 15,
    url: 'https://honeyguideapps.com/treks/everest-base-camp-and-gokyo-lakes-trek-cho-la-pass-trek.e160307c7274.everest-region',
    price: '',
    img: 'trip/e6b7acbf9101_bl.jpeg'
  },
  {
    name: 'Everest Three Passes Trek',
    day: '19',
    url: 'https://honeyguideapps.com/treks/everest-three-passes-trek.e77ca3a03b80.everest-region',
    price: '',
    img: 'trip/e27eac156eb0_bl.jpeg'
  },
  {
    name: 'Customize your trek',
    day: null,
    url: 'https://api.whatsapp.com/send?phone=+977-98410370673',
    price: '',
    img: 'everest-base-camp-trek-dingboche.jpg',
  },
];

export const Insights = [
  {
    name: 'Villages in Everest Region',
    desc: '',
    type: 'Local Insights',
    icon: 'icon-land icon--small icon-svg icon-svg--white',
    img: `${config.ASSETS_URL}/ashish-shrestha.jpg`,
    author: '',
    link: '/places?region=everest',
  },
  {
    name: 'Namche Village Profile',
    desc: '',
    type: 'Local Insights',
    icon: 'icon-land icon--small icon-svg icon-svg--white',
    img: `${config.ASSETS_URL}/nepali-travellers.jpg`,
    author: '',
    link: '/namche-bazaar.d840302e4958.everest-region',
  },
  {
    name: 'Guide Profile',
    desc: '',
    type: 'Local Insights',
    icon: 'icon-land icon--small icon-svg icon-svg--white',
    img: `${config.ASSETS_URL}/ashik-shrestha.jpg`,
    author: '',
    link: '/guides/suman-magar.a409289b3084/',
  },
  {
    name: 'Lodge Profile',
    desc: '',
    type: 'Local Insights',
    icon: 'icon-land icon--small icon-svg icon-svg--white',
    img: `${config.ASSETS_URL}/honeyguide.png`,
    author: 'HoneyGuide',
    link: '/khumbu-lodge.b2b6f9311369.namche-bazaar-lodges',
  },
  {
    name: 'EBC Trek cost for Indians',
    desc: '',
    type: 'Planning Tips',
    icon: 'icon-land icon--small icon-svg icon-svg--white',
    img: `${config.ASSETS_URL}/everest-marathon.png`,
    author: '',
    link: '/blog/everest-base-camp-trek-cost-from-india',
  },
  {
    name: 'Everything about Everest',
    desc: '',
    type: 'Planning Tips',
    icon: 'icon-land icon--small icon-svg icon-svg--white',
    img: `${config.ASSETS_URL}/snow-leopard-conservancy.jpg`,
    author: '',
    link: '/p/everything-about-the-everest-base-camp-trek',
  },
  {
    name: 'Best time to go to Everest',
    desc: '',
    type: 'Detailed Blogs',
    icon: 'icon-land icon--small icon-svg icon-svg--white',
    img: `${config.ASSETS_URL}/rajendra-suwal.jpg`,
    author: '',
    link: '/blog/everest-base-camp-best-time-to-go-seasonal-breakdown',
  },
  {
    name: 'Health and Safety Tips',
    desc: '',
    type: 'Planning Tips',
    icon: 'icon-land icon--small icon-svg icon-svg--white',
    img: `${config.ASSETS_URL}/jamling-tenzing-norgay.jpg`,
    author: '',
    link: '/p/health-and-safety-while-trekking-in-nepal',
  },
  {
    name: 'Lukla Flight Survival Guide',
    desc:'',
    type: 'Detailed Blogs',
    icon: 'icon-land icon--small icon-svg icon-svg--white',
    img: `${config.ASSETS_URL}/radioactive-wiki.jpeg`,
    author: '',
    link: '/blog/flight-to-lukla-a-survival-guide',
  },
  {
    name: 'EBC Trek in December',
    desc:'',
    type: 'Detailed Blogs',
    icon: 'icon-land icon--small icon-svg icon-svg--white',
    img: `${config.ASSETS_URL}/prasit-sthapit.jpg`,
    author: '',
    link: '/blog/everest-base-camp-trek-in-december',
  },
];

export const directConnectionData = [
  {
    lodgeName: 'About Us',
    location: '',
    desc:
      'Content: As John Muir says, “Thousands of tired, nerve-shaken, over-civilized people are beginning to find out that going to the mountains is going home; that wildness is a necessity.” HoneyGuide is an attempt to help thousands more discover this truth.',
    ownerName: 'About HoneyGuide',
    classNameNumber: 2,
    img: 'https://honeyguideapps.com/p/static/a82d61c419fd8ccf7e524dc6f444e54f/46793/Manaslu%204%20008.jpg',
    url: 'https://honeyguideapps.com/p/about-us',
  },
  {
    lodgeName: 'Edelweiss Lodge',
    location: 'Pheriche',
    desc:
      'I believe that lodges in Everest Region should focus on High Quality service and Self Empowerment',
    ownerName: 'Lhakpa Sherpa',
    classNameNumber: 3,
    img: 'assets/img/lhakpa-sherpa.jpeg',
    url: '/the-edelweiss.b5f96b220426.pheriche-lodges',
  },
  {
    lodgeName: 'Celebrate Six Seasons Video Competition',
    location: '',
    desc:
      'Content: HoneyGuide has been at the forefront of tackling the issue of seasonality in Nepal’s Adventure Tourism.',
    ownerName: 'Celebrate Six Seasons',
    classNameNumber: 4,
    img: 'https://honeyguideapps.com/p/static/21806f841ef1fa5a96de3b669fd49592/b30d8/sixseason.jpg',
    url: 'https://www.youtube.com/hashtag/honeyguide',
  },
  {
    lodgeName: 'Local Guide',
    location: '',
    desc:
      'I am happy to guide people through HoneyGuide because people can know that there is a guide named Sonam. I hope that I can get regular clients in trekking season time. I would love to show everybody my home town of Everest and take them to my small tea shop in Phakding as well!',
    ownerName: 'Sonam Dorjee Sherpa',
    classNameNumber: 6,
    img: 'https://s3.amazonaws.com/honeyguide/assets/soman-guide.jpg',
    url: '/sonam-dorjee-sherpa.a4d6fc0c92b7',
  },
  {
    lodgeName: 'Digitizing Tourism in the Everest Region.',
    location: '',
    desc:
      'Content: We work actively with the local community to manage the flow of trekkers, assure trekker safety, and increase tourism dividends for the local community.',
    ownerName: 'Tourism Honeyguide',
    classNameNumber: 7,
    img: 'https://blogsmedia.s3.amazonaws.com/blog/wp-content/uploads/2019/05/06101242/IMG_20190121_195200.jpg',
    url: '/blog/himalayas-2-0-everest-edition',
  },
  {
    lodgeName: 'Namaste Lodge and Restaurant',
    location: 'Monjo',
    desc:
      'I run a small lodge but I make sure every trekkers leave happily when they go. I even grow my own vegetables and serve organic food. At HoneyGuide, even small lodges like mine get equal opportunity to be noticed!',
    ownerName: 'Phuraphuti Sherpa',
    classNameNumber: 8,
    img: 'assets/img/phuraphuti-sherpa.jpg',
    url: '/namaste-lodge-and-restaurant.b80f1ffd0b93.monjo-lodges',
  },
  {
    lodgeName: 'Hotel Khangri',
    location: 'Namche Bazaar',
    desc: 'Hassle free online booking with availability of choices in the mountains.',
    ownerName: 'Dawang Sherpa',
    classNameNumber: 9,
    img: 'assets/img/dawang-sherpa.jpg',
    url: '/hotel-khangri.b9123c009dc0.namche-bazaar-lodges',
  },
];

export const coveredBy = [
  {
    name: 'Lonely Planet',
    url: 'https://www.lonelyplanet.com/news/2016/06/29/nepal-goes-hi-tech-new-app-trekking',
    desc:
      'Putting the HoneyGuide app ahead of its competitors, maps and trail descriptions can be used offline, so you can dip in and out of reception as you drop into mountain valleys without losing functionality. ',
    img: 'assets/img/lp.jpg',
  },
  {
    name: 'Best Hike',
    url: 'https://besthike.com/2018/09/07/new-app-trekking-in-nepal',
    desc:
      'Putting the HoneyGuide app ahead of its competitors, maps and trail descriptions can be used offline, so you can dip in and out of reception as you drop into mountain valleys without losing functionality. ',
    img: 'https://s3.amazonaws.com/honeyguide/assets/besthike.jpg',
  },
  {
    name: 'World Bank',
    url: 'http://www.infodev.org/articles/transforming-tourism-nepal-one-trek-time',
    desc:
      'Digital entrepreneurs often talk excitedly about disrupting industries, but rarely do you find such excitement when talking about guidebooks. Ashish Shrestha, one of the founders of Honeyguide, wants to give travelers to Nepal a better all-around experience, from booking their travel to navigating the trails and learning about the local culture.',
    img: 'https://s3.amazonaws.com/honeyguide/assets/woldbank.jpg',
  },
  {
    name: 'Business World',
    url:
      'http://bwdisrupt.businessworld.in/article/7-Startups-in-Nepal-That-Caught-Our-Eye-/23-06-2016-99539/',
    desc:
      'Guidebooks are dead!! Millennial travelers have no patience with its format or content. They want the technology to bend around their needs. While they are trekking, they don’t want a guidebook, they want a trekking app. And they want the technology to make them instant experts. HoneyGuide’s Trekking in Nepal provides just that through its features like Mountain Finder,    context sensitive Placecards, Deviation Alerts, complete lodge info in a small offline package.',
    img: 'https://s3.amazonaws.com/honeyguide/assets/businessworld.jpg',
  },
  {
    name: 'Kim Kim',
    url: 'https://www.kimkim.com/c/best-apps-for-nepal',
    desc:
      'HoneyGuide is Nepal\'s first trekking guide app. Pick your trek, then select categories of interest (mountains, flowers, animals, culture, etc.) so that you can preview and learn about what you\'ll come across.',
    img: 'https://s3.amazonaws.com/honeyguide/assets/kimkim.jpg',
  },
  {
    name: 'New Business Age',
    url: 'http://www.newbusinessage.com/MagazineArticles/view/1960',
    desc:
      'The app also provides information on each village on the trekking routes, such as all available lodges through GPS and information on flora and fauna in the localities. The app is in fact a one-stop solution for trekkers enabling them to have instant access to all necessary information even if they are offline.',
    img: 'assets/img/nba.jpg',
  },
  {
    name: 'A Year Off life',
    url: 'https://ayearofflife.com/2017/06/01/what-bring-us-together-annapurna-circuit/',
    desc:
      'Great app with plenty information about trip preparations, itineraries, lodges, and services. RECOMMENDED.',
    img: 'assets/img/ayl.jpg',
  },
];

export const happyClient = [
  {
    name: 'priya s',
    desc:
      'Omg, the view we got to witness !! Me and my sister wanted to visit kala patthar (without trekking)since February 2021 but it did not happened until recently. We took 1 night/2 days package. Our highlight of trip was the heli tour from lukla to kalapathhar. Unfortunately, due to government restrictions, we couldn’t land our heli there but trust me fly over is also not a bad bet. The captivating view of Himalayas was so unreal and still stays dear to my heart as a beautiful memory. And about the Everest View Hotel, couldn’t have asked for a better place/view to sip a glass of wine ;) To add cherry on top of the cake, we were fortunate enough to explore Lukla village and try warm and delicious Sherpa stew and other Tibetan food. My only complaint is we were not given any briefings and also there was no flyover to the base camp although it was clearly mentioned in our itinerary. All the staffs were amazing and pretty helpful. In short, if you are thinking about it, go for it !! It’s definitely going to be worthwhile, I promise!',
    img: 'https://media-cdn.tripadvisor.com/media/photo-l/1a/f6/e4/ca/default-avatar-2020-51.jpg',
    title: '',
  },
  {
    name: 'Ritik chitlangia',
    desc: 'It was a wonderful experience, the trip was very well planned and all experiences were pondered upon and catered to our personal requirements. Warm welcomes and comfortable stays at Lukla, Namchhe Bazar and HEV, made the trip more comfortable. Guides and porters were helpful and kind and answered our questions with the same excitement and interest. I would suggest people to plan such trips through Honey guide and see the mesmerising beauty of Nepal.',
    img: 'https://media-cdn.tripadvisor.com/media/photo-l/1a/f6/f1/06/default-avatar-2020-18.jpg',
    title: '',
  },
  {
    name: 'Priyanka MV',
    desc: 'To be honest, I wasn’t even sure if I would make it to EBC. I thought I could only make it to Namche Bazaar. Luckily, we came across Honeyguide’s page in Facebook. I contacted them and met with Mr. Ashish. He was extremely helpful and informative. Since my husband and I had very limited time, Honeyguide improvised our itinerary accordingly. We left for trekking in mid December; not exactly the best time for trekking. But with Honeyguide’s instruction and prior knowledge about trekking routes, gears and other necessities, the trip was much comfortable. The hotels that Honeyguide booked for us were amazing. Additionally, Mr. Ashish contacted us frequently to ensure that we were getting the best service. All the planning and help provided by Honeyguide enabled us to make not only to EBC but also to Cho La Pass, Gokyo Lake and Renjo La Pass in just 14 days.',
    img: 'https://media-cdn.tripadvisor.com/media/photo-l/1c/bb/3e/94/mavicheripink.jpg',
    title: '',
  },
  {
    name: 'lobsel',
    desc: 'Our everest base camp trek was amazingly beautiful .. the scenery along the way was awesome.. our trip was fully arranged by honeyguide who did a wonderful job .. it was during the pandemic when everest was finally open .. honeyguide was always a phonecall away n always updating us about the changes in the itenary coz of the pandemic .. met a lot of cool ppl along the way .. Will be doing gokyo next time ..',
    img: 'https://media-cdn.tripadvisor.com/media/photo-l/1a/f6/ea/74/default-avatar-2020-68.jpg',
    title: '',
  },
  {
    name: 'Jim Garvin',
    desc: `Overall we had a fantastic experience! Working with Honey Guide was great because it was very convienent, easy, and straight forward. I communicated with them via what's app to help schedule my flights to Lukla as well as to change my flight. We ended up finishing the EBC trek a few days early, and after a few messages back and forth in what's app, our flight was changed and I got an almost immediate email to confirm our new tickets. They are efficient, fast and easy to work with. Their pricing is also fair. Highly recommend!`,
    img: 'https://media-cdn.tripadvisor.com/media/photo-l/1a/f6/f0/48/default-avatar-2020-15.jpg',
    title: '',
  },
  
];



// WEBPACK FOOTER //
// ./src/screens/Landing/data.js